import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from './annualHourTrackerActionType';
import * as actions from './annualHourTrackerActions';
import * as services from './annualHourTrackerServices.js';
import { downloadBase64File } from "../../../../utils/fileDownloads";
import SweetAlert from '../../../../components/sweetalert/SweetAlert.js';


//------------------ Annual Hour Tracker - start------------------//
function* fetchAnnualHourTrackerSaga(action) {
    try {
        const response = yield call(services.getAllAnnualHourTracker, action.payload);
        if (!response) {
            throw new Error('No response received from API');
        }
        yield put(actions.fetchAnnualHourTrackerSuccess(response?.values));
    } catch (error) {
        let errorMessage = 'Failed to fetch annual hour tracker data.';
        console.error('Annual Hour Tracker API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });
        SweetAlert.error({ title: 'Error!', text: errorMessage });
        yield put(actions.fetchAnnualHourTrackerFailure(errorMessage));
    }
}

function* fetchAnnualHourTrackerDropdownSaga() {
    try {
        const response = yield call(services.getAllAnnualHourTrackerDropdown);
        if (response?.success) {
            yield put(actions.fetchAnnualHourTrackerDropdownSuccess(response?.values));
        } else {
            yield put(actions.fetchAnnualHourTrackerDropdownFailure('No dropdown data found'));
        }
    } catch (error) {
        console.error('Annual Hour Tracker Dropdown Fetch Error:', error);
        yield put(actions.fetchAnnualHourTrackerDropdownFailure('Failed to fetch dropdown data'));
    }
}

function* fetchWorklistByRPCESaga(action) {
    try {
        const response = yield call(services.getWorklistByRPCE, action.payload);
        if (response?.success) {
            yield put(actions.fetchWorklistByRPCESuccess(response?.values?.WorkListDropdownItems || []));
        } else {
            yield put(actions.fetchWorklistByRPCEFailure("No worklist found"));
        }
    } catch (error) {
        console.error("Worklist fetch error:", error);
        yield put(actions.fetchWorklistByRPCEFailure("Failed to fetch worklist"));
    }
}

function* fetchTaskByWorklistSaga(action) {
    try {
        const response = yield call(services.getTaskByWorklist, action.payload);
        if (response?.success) {
            yield put(actions.fetchTaskByWorklistSuccess(response?.values?.Tasks || []));
        } else {
            yield put(actions.fetchTaskByWorklistFailure("No tasks found"));
        }
    } catch (error) {
        console.error("Task fetch error:", error);
        yield put(actions.fetchTaskByWorklistFailure("Failed to fetch tasks"));
    }
}

function* exportCSVSagaAnnualHourTracker(action) {
    try {
        const { exportAPIURL, payload, moduleName, fileName } = action.payload;

        const response = yield call(services.exportCSVAnnualHourTracker, exportAPIURL, payload);

        const base64Data = response?.values || response;
        yield call(downloadBase64File, base64Data, moduleName, fileName);
        SweetAlert.success({ title: 'Success!', text: 'Annual Hour Tracker report exported successfully.' });
        yield put(actions.exportToCSVSuccessAnnualHourTracker(response));

    } catch (error) {
        console.error("Export error:", error);
        SweetAlert.error({ title: 'Error!', text: 'Annual Hour Tracker report Export failed. Please try again.' });
        yield put(actions.exportToCSVFailureAnnualHourTracker("Annual Hour Tracker report Export failed"));
    }
}

function* refreshAnnualHourTrackerSaga(action) {
    try {
        const response = yield call(services.refreshAnnualHourTracker, action.payload);
        if (response?.success) {
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Provider Schedule saved successfully.'
            });
            yield put(actions.refreshAnnualHourTrackerSuccess(response.values));

            // Fetch updated data after successful refresh
            if (action.payload?.fetchParams) {
                yield put(actions.fetchAnnualHourTrackerRequest(action.payload.fetchParams));
            }
        } else {
            const errorMessage = response?.errorMessage || 'Failed to save Provider Schedule';
            SweetAlert.error({ title: 'Error!', text: errorMessage });
            yield put(actions.refreshAnnualHourTrackerFailure('Refresh failed'));
        }
    } catch (error) {
        const errorMessage = 'Failed to refresh Annual Hour Tracker';
        SweetAlert.error({ title: 'Error!', text: errorMessage });
        yield put(actions.refreshAnnualHourTrackerFailure('Failed to refresh Annual Hour Tracker'));
    }
}
//------------------ Annual Hour Tracker - end------------------//


export default function* annualHourTrackerSaga() {
    //Annual Hour Tracker - start
    yield takeEvery(types.FETCH_ANNUAL_HOUR_TRACKER_REQUEST, fetchAnnualHourTrackerSaga);
    yield takeEvery(types.FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_REQUEST, fetchAnnualHourTrackerDropdownSaga);
    yield takeEvery(types.FETCH_ANNUAL_WORKLIST_BY_RPCE_REQUEST, fetchWorklistByRPCESaga);
    yield takeEvery(types.FETCH_TASK_BY_WORKLIST_REQUEST, fetchTaskByWorklistSaga);
    yield takeEvery(types.EXPORT_TO_CSV_REQUEST_ANNUAL_HOUR_TRACKER, exportCSVSagaAnnualHourTracker);
    yield takeEvery(types.REFRESH_ANNUAL_HOUR_TRACKER_REQUEST, refreshAnnualHourTrackerSaga);
    //Annual Hour Tracker - end
}